const KEYS_SORTED = [
  'executiveAssistantV2',
  'socialMediaManager',
  'contentCreator',
  'salesAssistant',
  'customerSupport',
  'legalAssistant',
  'receptionist',
]

export const AppConstants = {
  KEYS_SORTED,
}
